import './App.css';
import TShirtCustomizer from './components/customizer/TShirtCustomizer';

function App() {
  return (
    <div className="App">
      <TShirtCustomizer/>
    </div>
  );
}

export default App;
